import { render, staticRenderFns } from "./communicationDashboardSlideManager.vue?vue&type=template&id=5529f694&scoped=true"
import script from "./communicationDashboardSlideManager.vue?vue&type=script&lang=js"
export * from "./communicationDashboardSlideManager.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardSlideManager.vue?vue&type=style&index=0&id=5529f694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529f694",
  null
  
)

export default component.exports